import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initDataLayer } from '@/lib/gtm';
import { trackMetaPageView } from '@/lib/metaPixel';
import { usePageTracking } from '@/hooks/usePageTracking';
import { useEngagementTracking } from '@/hooks/useEngagementTracking';

interface GoogleTagManagerSetupProps {
  children: React.ReactNode;
}

const GoogleTagManagerSetup = ({ children }: GoogleTagManagerSetupProps) => {
  const location = useLocation();

  // Initialize dataLayer on mount
  useEffect(() => {
    initDataLayer();
  }, []);

  // Meta Pixel PageView per route — no-op without marketing consent
  useEffect(() => {
    if (location.pathname.startsWith('/admin') || location.pathname.includes('/admin/')) return;
    trackMetaPageView();
  }, [location.pathname]);

  // Track page views on route changes
  usePageTracking();
  
  // Track scroll depth and time on page
  useEngagementTracking();

  return <>{children}</>;
};

export default GoogleTagManagerSetup;
